document.addEventListener('DOMContentLoaded', () => {
  const PRODUCTO_UPSELL_ID = 40724541767834;
  const minPrice = 3999000;
  let timeoutId = null;

  // Función debounce para controlar las múltiples ejecuciones
  const debounce = (func, delay) => {
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
        timeoutId = null;
      }, delay);
    };
  };

  // Función para verificar y actualizar el carrito
  const verificarCarrito = async () => {
    try {
      console.log('Verifying cart')
      const response = await fetch('/cart.js');
      const { items, total_price } = await response.json();
      const isProductInCart = items.find(item => item.id === PRODUCTO_UPSELL_ID);

      if (total_price >= minPrice && !isProductInCart) {
        console.log('Adding free bag to cart')
        // Agregar el producto al carrito
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: PRODUCTO_UPSELL_ID,
              quantity: 1
            }]
          })
        });
        window.location.reload();
      }
    } catch (error) {
      console.error('Error al verificar el carrito:', error);
    }
  };

  // Versión debounceada de verificarCarrito
  const main = debounce(verificarCarrito, 300);

  // Configurar el observador para el elemento cart_count
  const cartCountElement = document.querySelector('.cart_count');
  if (cartCountElement) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          main();
        }
      });
    });

    // Configurar las opciones del observador
    const config = {
      childList: true,
      characterData: true,
      subtree: true
    };

    // Iniciar la observación
    observer.observe(cartCountElement, config);
  }
  main();
});
